export const RESET = 'bank-info:reset';
export const SET_BANKS = 'bank-info:set-banks';
export const SET_SELECTED_BANK = 'bank-info:set-selected-bank';

export const SET_CLEARING_NUMBER = 'bank-info:set-clearing-number';
export const SET_CLEARING_NUMBER_IS_VALID = 'bank-info:set-clearing-number-is-valid';
export const SET_CLEARING_NUMBER_SUPPRESS_ERROR = 'bank-info:set-clearing-number-suppress-error';
export const SET_CLEARING_NUMBER_ERROR_MESSAGE = 'bank-info:set-clearing-number-error-message';

export const SET_ACCOUNT_NUMBER = 'bank-info:set-account-number';
export const SET_ACCOUNT_NUMBER_IS_VALID = 'bank-info:set-account-number-is-valid';
export const SET_ACCOUNT_NUMBER_SUPPRESS_ERROR = 'bank-info:set-account-number-suppress-error';
export const SET_ACCOUNT_NUMBER_ERROR_MESSAGE = 'bank-info:set-account-number-error-message';



/** WEBPACK FOOTER **
 ** ./src/redux/modules/bank-info/action-types.js
 **/